import React, { useEffect, useRef, useState } from "react";
import api from "../../service/api";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import InputField from "../../components/forms/InputField";
import halfProgress from "../../assets/images/halfProgress.svg";
import fullProgress from "../../assets/images/fullProgress.svg";
import { closePaymentModal, useFlutterwave } from "flutterwave-react-v3";
import { Amount } from "../../components/meter";
import className from "classnames"
import { Tools } from "../../utils";
import { MdVerifiedUser } from "react-icons/md";
import flutterlogo from "../../assets/images/idBGQZQXup_logos.png"
import serrbitlogo from "../../assets/images/seerbitlogo.png"
import { useSeerbitPayment } from "seerbit-reactjs"


interface TransactionOptions {
  currency: string;
}

interface Transaction {
  id: string;
  meterNumber: string;
  product: string;
  time: string;
  status: string;
  token: string;
  amount: string;
  createdAt: string;
  transactionStatus: string;

  options: TransactionOptions;
}

const Utilities: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [powerType, setPowerType] = useState<"Grid" | "Generator" | "">("");
  const [showError, setShowError] = useState(false);
  const navigate = useNavigate();
  const userString = localStorage.getItem("user");
  const user = userString ? JSON.parse(userString) : null;
  const [userData, setUserData] = useState({
    product: "",
    email: "",
    phone: "",
    estate: user?.estate || "",
    meter: user?.meterNumber || "",
    amount: "",
  });

  const formatAmount = (amount: number) => {
    return amount.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };
  const serviceCharge = 0.015 * Number(userData.amount);
  const totalAmountString = formatAmount(
    Number(userData.amount)
  );
  const totalAmount = Number(userData.amount);

  const subAccount = process.env.REACT_APP_SUB_ACCOUNT;
  const [ meterType, setMeterType] = useState("");
  const [meterFound, setMeterFound] = useState(false);
  const mounted = useRef(false);
  const estate = user?.estate;

 useEffect(() => {
    mounted.current = true;
    const handleMeter = async () => {
      setMeterFound(false);
      try {
        if (userData.meter.length === 11) {
          setLoading(true);
          const authToken = localStorage.getItem("token");
          const headers = {
            Authorization: `Bearer ${authToken}`,
          };
          const data = await api.req(
            `/meter/${userData.meter}/${estate}`,
            "GET",
            null,
            authToken
          );
          if (data.status === "success") {
            setMeterType(data.data.details.meterType);
            localStorage.setItem("meterType", JSON.stringify(data.data.details.meterType))
            setMeterFound(true);
            setLoading(false);
            // const response = await api.req(`/meter/vending/${userData.meter}`);
            // if (response.status === "success") {
            //   setMeterType(data.data.details.meterType);
            //   setMeterFound(true);
            //   setLoading(false);
            //   localStorage.setItem("meterType", JSON.stringify(data.data.details.meterType))
            //   return;
            // } else {
            //   setShowAlert(true);
            //   setMeterFound(false);
            //   setAlertMessage(response.message);
            //   setTimeout(() => setShowAlert(false), 3000);
            //   setLoading(false);
            //   return;
            // }
          } else {
            setShowAlert(true);
            setMeterFound(false);
            setAlertMessage(data.message);
            setTimeout(() => setShowAlert(false), 3000);
            setLoading(false);
            return;
          }
        }
        setLoading(false);
      } catch (error) { }
    };
    handleMeter();

    return () => {
      mounted.current = false;
    };
  }, [userData.meter, estate]);
  const r = {
    onChange(
      e:
        | React.ChangeEvent<HTMLInputElement>
        | React.ChangeEvent<HTMLSelectElement>
    ) {
      setUserData({
        ...userData,
        [e.target.name]: e.target.value,
      });
    },
  };

  const [isReviewOrder, setIsReviewOrder] = useState(true); // Track the current view
  const [showServiceFeeModal ,setShowServiceFeeModal] = useState(false)

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUserData({
      ...userData,
      [e.target.name]: e.target.value,
    });
  };

// const serviceFeeMeters = [
//   "58102534672",
//   "58102484548",
//   "58102534565",
//   "58102484589",
//   "58101373395",
//   "58101373346",
//   "58101373361",
//   "58103636138",
// ];




 

  const handleBack = () => {
    setIsReviewOrder(true); // Return to the form view
  };

  // Payment Break down

  const handleFlutterwave = useFlutterwave(
    Tools.paymentConfig(
      totalAmount,
      userData.email,
      userData.phone,
      subAccount,
      userData.product
    ) as any
  );

  const handleTransaction = async (reference: string) => {
      // if (!isReviewOrder) return;
    try {
      setLoading(true);
      const body = {
        meterNumber: userData.meter,
        product: userData.product,
        amount: userData.amount,
        email: userData.email,
        phone: userData.phone,
        reference,
        meterType,
        estate,
        powerType: userData.product,
      };
      localStorage.setItem("details", JSON.stringify(body));
      const data = await api.req("/transaction/add", "POST", body);
      if (data.status !== "success") {
        setShowAlert(true);
        setAlertMessage(data.message);
        setTimeout(() => setShowAlert(false), 3000);
        return false;
      }
      localStorage.setItem("date", data.data.details.createdAt);
      const payload = {
        meterNumber: userData.meter,
        amount: userData.amount,
        meterType,
        powerType: userData.product,
      };
      const response = await api.req(
        "/transaction/generate_token",
        "POST",
        payload
      );
      if (response.status !== "success") {
        setShowAlert(true);
        setAlertMessage(response.message);
        setTimeout(() => setShowAlert(false), 3000);
        return false;
      }
      localStorage.setItem("meterToken", response.data.token);
      if (localStorage.getItem("meterToken") !== response.data.token) {
        setShowAlert(true);
        setAlertMessage(
          "Failed to save token locally. Go to your dashboard to get token."
        );
        setTimeout(() => setShowAlert(false), 3000);
        return false;
      }
      const updatedTrx = await api.req(
        `/transaction/${data.data.details.id}`,
        "PATCH",
        { token: response.data.token }
      );
      if (updatedTrx.status === "failed") {
        setShowAlert(true);
        setAlertMessage(updatedTrx.message);
        setTimeout(() => setShowAlert(false), 3000);
        return false;
      }
      navigate("/dashboard");
      return true;
    } catch (error) {
      setShowAlert(true);
      setAlertMessage("An error occurred. Please try again.");
      setTimeout(() => setShowAlert(false), 3000);
      return false;
    } finally {
      setLoading(false);
    }
  };

  const handlePayment = () => {
  
    if (!userData.product) {
      setShowError(true);
      return;
    }
    try {
      handleFlutterwave({
        callback: async (response) => {
          console.log(response, "response");
          if (
            response.status === "successful" ||
            response.status === "completed"
          ) {
            // setUserData({
            //   meter: "",
            //   amount: "",
            //   phone: "",
            //   email: "",
            //   product: "",
            //   estate: "",
            // });
            await handleTransaction(response.tx_ref);
          } else {
            setShowAlert(true);
            setAlertMessage("Transaction Failed");
            setTimeout(() => setShowAlert(false), 3000);
            navigate("/homePage");
          }
          closePaymentModal();
        },
        onClose: () => { },
      });
    } catch (error) {
      // Handle error
    }
  };


  // seerbit
  const seerbitKey:any = process.env.REACT_APP_PUBLIC_KEY_SEERBIT
  const options :any = {
    public_key: seerbitKey,
    amount: totalAmount.toString(),
    tranref: new Date().getTime(),
    currency: "NGN",
    email: userData.email,
    full_name: userData.product,
    mobile_no: userData.phone,
    tokenize: false, // Changed from boolean to string
    pocketId: "",
    vendorId: "",
    description: "Payment for utilities",
    country: "NG",
    callbackurl: "",
    clientappcode: "yourclientappcode",
    customization: JSON.stringify({
      theme: {
        border_color: "#000000",
        background_color: "#004C64",
        button_color: "#0084A0",
      },
      payment_method: ["transfer", "account", "card", "ussd"],
      display_fee: true,
      display_type: "embed",
      logo: "logo_url | base64",
    }),
  };
  
  // Define the type for the close function
  const close = () => {
    console.log(close);
  };

  const callback = async (response: any, closeCheckout: any) => {
    console.log(response, "Seerbit response");
  
      if (response.message === "Successful") {
        await handleTransaction(response?.payments.paymentReference); // Ensure payment is passed correctly
        // navigate("/dashboard"); // Redirect to receipt page after successful transaction
      } else {
        setShowAlert(true);
        setAlertMessage("Transaction Failed");
        setTimeout(() => setShowAlert(false), 3000);
        navigate("/homePage"); // Redirect to homepage if transaction fails
      }
  

    setTimeout(() => closeCheckout(), 2000);
  };

// ts-ignore
  const initializePayment = useSeerbitPayment(options, callback, close);

  
// const handleReviewOrder = () => {
//   const { meter, amount, email, product, phone } = userData;

//   if (meter && amount && email && product && phone) {
//     if (serviceFeeMeters.includes(meter)) {
//       // Show modal instead of alert
//       setShowServiceFeeModal(true); // Assuming you use a modal component controlled by this state
//     } else {
//       setIsReviewOrder(false); // Proceed to review order
//     }
//   } else {
//     alert("Please fill in all fields and a verified meter");
//   }
// };
  
const handleReviewOrder = () => {
  const { meter, amount, email, product, phone } = userData;

  if (meter && amount && email && product && phone) {
    setIsReviewOrder(false); // Proceed to review order
  }
};
  


  return (
    <>

      {isReviewOrder ? (
        <div
          style={{
            background: "white",
            width: "100%",
            height: "100vh",
            padding: "0rem",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              width: "100%",
              padding: "2rem 1rem",

              display: "flex",
              gap: "5rem",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <AiOutlineArrowLeft
              color={"black"}
              className="bg-[#F4F1F1]"
              size={20}
              onClick={() => {
                navigate("/homePage");
              }}
            />
            <p style={{ fontSize: "1.5rem" }}>Buy Utilities</p>
          </div>
          <div className="flex justify-between items-center px-4">
            <p className="text-center text-xl">Register to Buy Utilities</p>
            <div className="flex gap-1 items-center">
              <p>step 1 of 2</p>
              <img src={halfProgress} alt="progress" />
            </div>
          </div>
          <form className="mt-4 px-4 flex flex-col w-full">
            <div className="relative">
              <label className="block text-sm font-medium text-gray-700">
                Product Type
              </label>
              <select
                name="product"
                value={userData.product}
                onChange={(e) => r.onChange(e)}
                className="mt-1 block border-[#CC5C08] bg-[#FFF9EA]  w-full pl-3 pr-10 py-4 text-base border-[1px] focus:outline-none focus:ring-[#CC5C08] focus:border-[#CC5C08] sm:text-sm rounded-md"
              >
                <option value="" disabled>
                  Select product type
                </option>
                <option value="Grid">Grid Power</option>
                <option value="Generator">Generator Power</option>
                <option value="Water">Water</option>
              </select>
            </div>
            <div className="relative">
<InputField
  label="Meter Number"
  value={userData.meter}
  onChange={(e) => r.onChange(e)}
  placeholder="Enter your meter number"
  name="meter"
  type="text"
  meterFound={meterFound}
  isReadOnly={true} // 🔒 Makes it non-editable
/>


              {meterFound ? (
                <p className="text-green-500 text-sm mt-1 flex items-center ">Meter Verified <MdVerifiedUser />  </p>
              ) : (
                !meterFound && userData.meter.length > 11 && (<p className="text-red-500 text-sm mt-1">Meter not found</p>)
              )}
            </div>
            <div className=" w-full">
              <InputField
                label="How much would you like to buy?"
                type={"text"}
                placeholder="Enter amount"
                name="amount"
                onChange={(e) => r.onChange(e)}
                value={userData.amount}
              />
            </div>
            <div className=" w-full">
              <InputField
                label="Email Address"
                type={"text"}
                placeholder="Enter your email address"
                name="email"
                onChange={(e) => r.onChange(e)}
                value={userData.email}
              />
            </div>
            <div className=" w-full">
              <InputField
                label="Phone Number"
                type={"text"}
                placeholder="Enter your phone number"
                name="phone"
                onChange={(e) => r.onChange(e)}
                value={userData.phone}
              />
            </div>

            <div className="w-full py-12">
              <button
                className="bg-primary w-full text-center text-[16px] hover:bg-[#fff] text-white font-semibold py-2 hover:text-primary px-6 border border-primary  rounded-md"
                onClick={handleReviewOrder}

              >
                Review Order
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div
          style={{
            background: "white",
            width: "100%",
            height: "100vh",
            padding: "0rem",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              width: "100%",
              padding: "2rem 1rem",

              display: "flex",
              gap: "5rem",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <AiOutlineArrowLeft
              color={"black"}
              className="bg-[#F4F1F1]"
              size={20}
              onClick={handleBack}
            />
            <p style={{ fontSize: "1.5rem" }}>Buy Utilities</p>
          </div>
          <div className="flex justify-between pb-6 items-center px-4">
            <p className="text-center text-xl">Review Purchase</p>
            <div className="flex gap-1 items-center">
              <p>step 2 of 2</p>
              <img src={fullProgress} alt="progress" />
            </div>
          </div>
          <main className="flex flex-col gap-4 px-4 ">
            <main className=" flex flex-col text-[#000000] ">
              <div className="flex justify-between  py-2">
                <div className="flex flex-col ">
                  <p className="text-[12px] leading-[18px] font-medium text-[#000000]  ">
                    Product
                  </p>
                  <p className="text-[12px] leading-[24px] font-semibold text-secondaryLight ">
                    {userData.product} {userData.product === "Grid" ? "Power" : ""}
                  </p>
                </div>
                <div className="flex flex-col text-right ">
                  <p className="text-[12px] leading-[24px] ">Meter Number</p>
                  <p className="text-[12px] leading-[24px] font-semibold text-secondaryLight ">
                    {userData.meter}
                  </p>
                </div>
              </div>
              <div className="flex justify-between  py-2">
                <div className="flex flex-col ">
                  <p className="text-[12px] leading-[24px] ">Email Address</p>
                  <p className="text-[12px] leading-[24px] font-semibold text-secondaryLight">
                    {userData?.email}
                  </p>
                </div>
                <div className="flex flex-col text-right ">
                  <p className="text-[12px] leading-[24px] ">Phone Number</p>
                  <p className="text-[12px] leading-[24px] font-semibold text-secondaryLight">
                    {userData?.phone}
                  </p>
                </div>
              </div>
              <div className="flex justify-between  py-2">
                <div className="flex flex-col ">
                  <p className="text-[12px] leading-[24px] ">Device Estate</p>
                  <p className="text-[12px] leading-[24px] font-semibold text-secondaryLight">
                    {userData?.estate}
                  </p>
                </div>
                <div className="">
                  <div className="flex flex-col text-right">
                    <p className="text-[12px] leading-[24px] ">Status</p>
                    <p className="text-[12px] leading-[24px] font-semibold text-secondaryLight">
                      {"Successful"}
                    </p>
                  </div>
                </div>
              </div>

              {/* Payment Break down */}
              <div className="flex flex-col  pt-12 text-secondaryLight">
                <p className="text-[14px] leading-[21px] text-secondary">
                  Payment Breakdown
                </p>
                <div className="flex flex-col  ">
                  <div className="flex justify-between">
                    <p className="text-[12px] leading-[24px] ">
                      Utility Amount:
                    </p>
                    <p className="text-[12px] leading-[24px] font-medium text-secondaryLight">
                      ₦ {formatAmount(Number(userData.amount))}
                    </p>
                  </div>
                  <div className="flex justify-between">
                    <p className="text-[12px] leading-[24px] ">
                      Service Charge:
                    </p>
                    <p className="text-[12px] leading-[24px] font-medium text-secondaryLight">
                      ₦0
                    </p>
                  </div>
                </div>
                <div className="flex justify-between py-4">
                  <div className="flex jutiify-between">
                    <p className="text-[12px] leading-[24px] text-[#242222] ">
                      Total:
                    </p>
                  </div>
                  <p className="text-[12px] leading-[24px] font-bold text-[#242222]">
                    ₦ {totalAmountString}
                  </p>
                </div>
              </div>

              {/* <div className="flex justify-between pt-6 w-full">
                <button
                  className="w-full bg-transparent hover:bg-[#CD5C08] text-primary transition-all font-semibold hover:text-white px-6 py-4 border border-primary hover:border-transparent rounded"
                  onClick={handlePayment}
                >
                  Pay Now
                </button>
              </div> */}
              <div className="flex flex-col gap-4 pt-6 w-full">

                {/* Seerbit Button */}
                <button
                  className="w-full bg-white hover:bg-red-700 text-red-700 hover:text-white font-semibold px-6 py-2 border border-red-700 rounded-lg shadow-md hover:shadow-lg transition-all flex items-center justify-center gap-2"
                  onClick={initializePayment}
                >
                  <img src={serrbitlogo} alt="Seerbit" className="h-4 w-24" />
                  Pay with Seerbit
                </button>
                                {/* Flutterwave Button */}
                    <button
                  className="w-full bg-white hover:bg-orange-600 hover:text-white text-orange-600 font-semibold px-6 py-2 border border-orange-600 rounded-lg shadow-md hover:shadow-lg transition-all flex items-center justify-center gap-2"
                  onClick={handlePayment}
                >
                  <img src={flutterlogo} alt="Flutterwave" className="h-6 w-6" />
                  Pay with Flutterwave
                </button> 
              </div>

            </main>
          </main>
        </div>
      )}
        {showServiceFeeModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-[90%] max-w-md p-6 text-center">
            <h2 className="text-lg font-semibold mb-4 text-gray-800">Service Fee Required</h2>
            <p className="text-sm text-gray-600 mb-6">
              Opps!!! you need to pay your service fee,contact the facility manager for more enquiries
            </p>
            <button
              className="bg-orange-600 text-white px-4 py-2 rounded hover:bg-orange-700"
              onClick={() => {
                setShowServiceFeeModal(false);
              }}
            >
              Go Back
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Utilities;
